import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";

const tiers = [
  {
    id: "starter", name: "Single Reel", price: 20, testid: "pricing-tier-20-card", btn: "select-plan-20-button", popular: false,
    tag: "Test the magic",
    features: ["1 viral 9:16 reel", "48-hour delivery", "Trending audio + captions", "Full usage rights"],
  },
  {
    id: "growth", name: "Growth Bundle", price: 55, testid: "pricing-tier-50-card", btn: "select-plan-50-button", popular: true,
    tag: "Most popular",
    features: ["3 viral reels", "24-hour delivery", "Hook variations for A/B testing", "Trending audio + captions", "Full usage rights"],
  },
  {
    id: "domination", name: "Domination Pack", price: 100, testid: "pricing-tier-100-card", btn: "select-plan-100-button", popular: false,
    tag: "Scale fast",
    features: ["5 viral reels", "24-hour priority delivery", "Multi-format (Reels + Stories)", "Dedicated creator", "Priority support", "Full usage rights"],
  },
];

export const Pricing = ({ onSelect }) => (
  <section id="pricing" data-testid="pricing-section" className="py-16 lg:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <div className="max-w-2xl mx-auto text-center">
        <p className="text-xs font-mono uppercase tracking-widest text-[#00F5D4] mb-3">Transparent pricing</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
          One flat price. Pay once, go viral.
        </h2>
        <p className="mt-4 text-slate-400">No subscriptions, no retainers. Pick a pack, pay securely, get your reels in 24 hours.</p>
      </div>

      <div className="mt-12 grid lg:grid-cols-3 gap-5 items-start">
        {tiers.map((t, i) => (
          <motion.div key={t.id} data-testid={t.testid}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.45, delay: i * 0.1 }}
            className={`relative rounded-2xl p-7 border transition-colors ${
              t.popular
                ? "bg-[#12141C] border-[#00F5D4]/50 shadow-[0_0_40px_-12px_rgba(0,245,212,0.4)] lg:-mt-4 lg:mb-4"
                : "bg-[#12141C] border-white/10 hover:border-[#FF2E63]/40"
            }`}>
            {t.popular && (
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 rounded-full bg-[#00F5D4] text-[#0A0B10] text-xs font-bold px-3 py-1">
                <Star className="w-3.5 h-3.5 fill-[#0A0B10]" /> Most Popular
              </span>
            )}
            <p className="text-xs font-mono uppercase tracking-widest text-slate-500">{t.tag}</p>
            <h3 className="mt-2 font-display text-xl font-semibold">{t.name}</h3>
            <div className="mt-4 flex items-end gap-1">
              <span className="font-display text-5xl font-extrabold">${t.price}</span>
              <span className="text-slate-500 text-sm mb-2">one-time</span>
            </div>
            <ul className="mt-6 space-y-3">
              {t.features.map((f) => (
                <li key={f} className="flex items-start gap-2.5 text-sm text-slate-300">
                  <Check className={`w-4 h-4 mt-0.5 shrink-0 ${t.popular ? "text-[#00F5D4]" : "text-[#FF2E63]"}`} /> {f}
                </li>
              ))}
            </ul>
            <button data-testid={t.btn} onClick={() => onSelect(t.id)}
              className={`mt-7 w-full rounded-full font-semibold py-3 transition-colors ${
                t.popular ? "bg-[#00F5D4] hover:bg-[#00d9bd] text-[#0A0B10]" : "bg-[#FF2E63] hover:bg-[#E02554] text-white"
              }`}>
              Order now
            </button>
          </motion.div>
        ))}
      </div>
      <p className="mt-6 text-center text-xs text-slate-500">Secure checkout via Razorpay · Instant order confirmation</p>
    </div>
  </section>
);
